import React, { useState } from "react";
import { categorias } from "../../../../constants/HomeCupom/categoryIcon";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { useTheme, useMediaQuery } from "@mui/material";

import * as S from "./Styled";

// Espaço entre os cards no mobile (entra no cálculo de S.MOBILE_CARD_WIDTH)
const MOBILE_GAP = 12;

export default function CategoryCarousel() {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    const isTablet = useMediaQuery(theme.breakpoints.down("md"));

    const itemsPerPage = isMobile ? 2 : isTablet ? 4 : 6;
    const itemWidth = isMobile ? 130 : 150;
    const gap = 26;
    const containerWidth = itemsPerPage * itemWidth + (itemsPerPage - 1) * gap;

    const [currentIndex, setCurrentIndex] = useState(0);
    const totalItems = categorias.length;
    const maxIndex = Math.max(totalItems - itemsPerPage, 0);

    const handlePrev = () => setCurrentIndex((prev) => Math.max(prev - 1, 0));
    const handleNext = () => setCurrentIndex((prev) => Math.min(prev + 1, maxIndex));

    const cards = categorias.map((cat, index) => (
        <S.CategoryCard
        key={index}
        href={`https://www.meucupom.com/cupom-desconto-${cat.slug}`}
        target="_blank"
        rel="noopener noreferrer"
        width={itemWidth}
        >
        {cat.icon}
        <S.CategoryName
            isMobile={isMobile}
            isSmall={cat.slug === "eletrodomesticos"}
        >
            {cat.nome}
        </S.CategoryName>
        </S.CategoryCard>
    ));

    // Mobile: sem setas, o usuário arrasta com o dedo
    if (isMobile) {
        return (
            <S.Container>
                <S.SwipeArea>
                    <S.CarouselContent gap={MOBILE_GAP} translate={0}>
                        {cards}
                    </S.CarouselContent>
                </S.SwipeArea>
            </S.Container>
        );
    }

    return (
        <S.Container>
        {currentIndex > 0 && (
            <S.ArrowButtonLeft onClick={handlePrev}>
            <ArrowBackIosNewIcon />
            </S.ArrowButtonLeft>
        )}

        <S.CarouselArea width={containerWidth}>
            <S.CarouselContent
            gap={gap}
            translate={currentIndex * (itemWidth + gap)}
            >
            {cards}
            </S.CarouselContent>
        </S.CarouselArea>

        {currentIndex < maxIndex && (
            <S.ArrowButtonRight onClick={handleNext}>
            <ArrowForwardIosIcon />
            </S.ArrowButtonRight>
        )}
        </S.Container>
    );
}
